//import IPagination from 'interfaces/IPagination';
import { combineReducers } from 'redux';

//import { IConversionList } from './interfaces';
import ClickConversionTypes from './types';

// const searchInitialState: {
//   isFetching: boolean;
//   items: IConversionList[];
//   pagination?: IPagination;
//   error?: any;
// } = { isFetching: false, items: [] };

export const clickConversionReducer = combineReducers({
  search: ClickConversionTypes.search.getReducer(),
  graphics: ClickConversionTypes.graphics.getReducer(),
  graphicsSales: ClickConversionTypes.graphicsSales.getReducer(),
  utmsGraphic: ClickConversionTypes.utmsGraphic.getReducer(),
  topPaymentMethods: ClickConversionTypes.topPaymentMethods.getReducer(),
  topAffiliates: ClickConversionTypes.topAffiliates.getReducer(),
  listUtms: ClickConversionTypes.listUtms.getReducer(),
  listCampaigns: ClickConversionTypes.listCampaigns.getReducer(),
});
